module.exports = __webpack_public_path__ + "static/media/lang-icon.bd23ba49.png";